import { createFileRoute } from '@tanstack/react-router'

import { BlytzCollectAnalyticsScreen } from '../../components/blytz-collect-analytics-screen.tsx'

export const Route = createFileRoute('/blytzcollect/analytics')({
  component: BlytzCollectAnalyticsScreen
})
